/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_3_TitleInputs */

const en_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Your Focus Habit`)
};

const ar_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابنى عادة التركيز الخاصة بك`)
};

const de_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bauen Sie Ihre Fokus-Gewohnheit auf`)
};

const es_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye tu hábito de concentración`)
};

const fr_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développez votre habitude de concentration`)
};

const it_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppa la tua abitudine alla concentrazione`)
};

const ja_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中する習慣を身につける`)
};

const ko_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 습관을 만드세요`)
};

const pt_br_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolva seu hábito de foco`)
};

const ru_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выработайте привычку концентрации`)
};

const th_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างนิสัยการโฟกัสของคุณ`)
};

const tr_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Alışkanlığı Oluştur`)
};

const zh_cn_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`培养你的专注习惯`)
};

const zh_tw_starter_challenge_phase_3_title = /** @type {(inputs: Starter_Challenge_Phase_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`培養你的專注習慣`)
};

/**
* | output |
* | --- |
* | "Build Your Focus Habit" |
*
* @param {Starter_Challenge_Phase_3_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_3_title = /** @type {((inputs?: Starter_Challenge_Phase_3_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_3_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_3_title(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_3_title(inputs)
	if (locale === "de") return de_starter_challenge_phase_3_title(inputs)
	if (locale === "es") return es_starter_challenge_phase_3_title(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_3_title(inputs)
	if (locale === "it") return it_starter_challenge_phase_3_title(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_3_title(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_3_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_3_title(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_3_title(inputs)
	if (locale === "th") return th_starter_challenge_phase_3_title(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_3_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_3_title(inputs)
	return zh_tw_starter_challenge_phase_3_title(inputs)
});